import {makeStyles} from "tss-react/mui";

export const useEditorStyles = makeStyles()(
  (
    theme,
    {
      activeInForm,
      backgroundColor,
      disabled,
      error,
      inline,
      isForm,
      noLabel,
      resizingBar,
      expandedMode,
    },
  ) => ({
    labelActive: {
      display: noLabel ? "none" : undefined,
      transform: "translate(1px, -16px)",
      zIndex: 10,
      width: "100%",
      position: "relative",
      fontSize: "0.75rem",
      paddingLeft: theme.spacing(1.5),
      marginBottom: theme.spacing(1),
      pointerEvents: "none",
      color: error ? theme.palette.error.main : undefined,
      opacity: disabled ? 0.5 : undefined,
    },
    labelPlaceholder: {
      transform: "translate(0px, 10px)",
      zIndex: 10,
      position: "relative",
      fontSize: "1rem",
      fontWeight: 400,
      paddingLeft: theme.spacing(0.25),
      pointerEvents: "none",
      color: error ? theme.palette.error.main : undefined,
      opacity: disabled ? 0.5 : undefined,
    },
    labelEdit: {
      // A one-line block pulled half its height into the editor sits on the top border, like
      // the outlined MUI fields around it.
      display: noLabel ? "none" : "block",
      width: "fit-content",
      lineHeight: 1,
      marginBottom: "-0.375rem",
      zIndex: 10,
      position: "relative",
      fontSize: "0.75rem",
      background: theme.palette.background.default,
      marginLeft: theme.spacing(1.5),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      pointerEvents: "none",
      color: error ? theme.palette.error.main : undefined,
      opacity: disabled ? 0.5 : undefined,
    },
    grid: {
      marginTop: isForm && !expandedMode ? theme.spacing(1.5) : undefined,
      marginRight: isForm ? theme.spacing(0.5) : undefined,
      paddingRight: isForm ? theme.spacing(0.25) : undefined,
    },
    editor: {
      ...(expandedMode && {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }),
      "&> .sun-editor": {
        ...(expandedMode && {
          flex: 1,
          display: "flex !important",
          flexDirection: "column",
        }),
        border: inline ?
          "none" :
          `1px solid ${
            error ?
              theme.palette.error.main :
              isForm && !activeInForm ?
                theme.palette.mode === "dark" ?
                  "#545454" :
                  "rgba(0, 0, 0, 0.23)" :
                theme.palette.primary.main
          }`,
        "@media print": {
          border: "none",
        },
      },
      "&>.sun-editor .se-btn-select.se-btn-tool-font": {
        width: theme.spacing(10),
      },
      "&>.sun-editor .se-btn": {
        color: theme.palette.primary.contrastText,
      },
      "&>.sun-editor .se-btn:enabled.active": {
        color: theme.palette.mode === "dark" ? "green" : "lightgreen",
        border: `2px dashed ${theme.palette.mode === "dark" ? "green" : "lightgreen"}`,
      },
      "&>.sun-editor .sun-editor-editable": {
        ...(expandedMode && {flex: 1}),
        padding: inline ? 0 : undefined,
      },
      "&>.sun-editor .sun-editor-editable p": {
        margin: 0,
      },
      "&>.sun-editor .sun-editor-editable h2": {
        marginBlockStart: ".1em",
        marginBlockEnd: ".1em",
      },
      "&>.sun-editor .se-container": {
        ...(expandedMode && {
          flex: 1,
          display: "flex !important",
          flexDirection: "column",
        }),
      },
      "&>.sun-editor .se-wrapper": {
        ...(expandedMode && {
          flex: 1,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }),
      },
      "&>.sun-editor .se-wrapper .se-wrapper-wysiwyg": {
        ...(expandedMode && {
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }),
        fontSize: inline ? 16 : undefined,
        backgroundColor: backgroundColor || theme.palette.background.paper,
        color: theme.palette.text.primary,
      },
      "&>.sun-editor .se-controller .se-btn-group": {
        backgroundColor: theme.palette.primary.main,
      },
      "&>.sun-editor .se-wrapper .se-wrapper-inner": {
        ...(expandedMode && {
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }),
        ...(!expandedMode && !inline && {minHeight: "200px"}),
        userSelect: "text",
      },
      "&>.sun-editor .se-wrapper .se-wrapper-inner .se-wrapper-wysiwyg": {
        ...(expandedMode && {height: "100%"}),
      },
      "&>.sun-editor .se-toolbar": {
        backgroundColor: theme.palette.primary.main,
        display: inline ? "none !important" : undefined,
        "@media print": {
          display: "none !important",
        },
      },
      "&>.sun-editor .se-toolbar-more-layer .se-more-layer .se-more-form": {
        backgroundColor: theme.palette.primary.main,
      },
      "&>.sun-editor .se-resizing-bar": {
        display: isForm && !resizingBar ? "none" : undefined,
        minHeight: isForm && resizingBar ? "unset" : undefined,
        backgroundColor: theme.palette.primary.main,
        "&>.se-navigation": {
          color: theme.palette.primary.contrastText,
        },
        "@media print": {
          display: "none !important",
        },
      },
      "&>.sun-editor .se-dialog .se-dialog-inner .se-dialog-content .se-btn-primary": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
      "&>.sun-editor .se-dialog .se-dialog-inner .se-dialog-header .se-dialog-close": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    staticEditor: {
      "&>.sun-editor .se-wrapper .se-notice": {
        display: "none",
      },
      "&>.sun-editor .se-container .se-controller": {
        display: "none",
      },
    },
  }),
);
